/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import classnames from "classnames/bind";
import * as React from "react";
import styles from "./error-message.module.css";

interface Props {
  message: string;
  visible?: boolean;
  classname?: string;
}

const cx = classnames.bind(styles);

const ErrorMessage: React.SFC<Props> = ({ message, classname }) => (
  <p className={cx("error-message", classname, { visible: message })}>{message}</p>
);

export default ErrorMessage;
